import { TenantEntity } from '../TenantEntity'

export class FreightCharges extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get chargeItemId() {
    return this._data.chargeItemId
  }
  set chargeItemId(chargeItemId) {
    this._data.chargeItemId = chargeItemId || 0
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0
  }
  get paymentTermHBL() {
    return this._data.paymentTermHBL
  }
  set paymentTermHBL(paymentTermHBL) {
    this._data.paymentTermHBL = paymentTermHBL
  }
  get unitRate() {
    return this._data.unitRate
  }
  set unitRate(unitRate) {
    this._data.unitRate = unitRate || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    this._data.eqType = eqType
  }
  get cargoDocUuid() {
    return this._data.cargoDocUuid
  }
  set cargoDocUuid(cargoDocUuid) {
    this._data.cargoDocUuid = cargoDocUuid
  }
}
